<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  mounted() {
    Bus.$on('openDeleteDealModal', () => this.handleOpen());
  },

  data() {
    return {
      observation: '',
      error: false,
      closingBySave: false,
    }
  },

  methods: {
    handleOpen() {
      this.$refs['deal-delete-modal'].show();
    },

    handleConfirm() {
      if(!this.observation.length) return this.error = true;
      this.$emit('confirmDeletion', this.observation);
      this.closingBySave = true;
      this.$refs['deal-delete-modal'].hide();
    },

    handleClose() {
      this.$refs['deal-delete-modal'].hide();
      this.closingBySave = false;
    },

    onModalHide() {
      if(!this.closingBySave) {
        Bus.$emit('reinsertDeal');
      }
      this.closingBySave = false;
      this.error = false;
      this.observation = '';
    }
  }
}
</script>

<template>
<BModal 
  id="deal-delete-modal"
  ref="deal-delete-modal"
  centered
  hide-header
  hide-footer
  @hide="onModalHide"
>
  <section>
    <div>
      <h1>{{ __("Deseja realmente excluir esse negócio?") }}</h1>
      <h2>{{ __("Para continuar informe o motivo no campo abaixo.") }}</h2>
    </div>
    <form>
      <div>
        <label>{{ __("Observações") }}</label>
        <textarea
          v-model="observation"
          :placeholder="__('Registre aqui suas observações...')"
          maxlength="100"
          @dragover.prevent
          @drop.prevent
        ></textarea>
        <img 
          v-if="error"
          src="/build/icons/exclamation-circle.svg" 
          width="18" 
          height="18"
        />
      </div>
      <p 
        v-if="error"
        class="error-text"
      >
        {{ __("*O campo observações deve ser peenchido.") }}
      </p>
    </form>
    <div class="warning-container">
      <span>{{ __("Ao clicar em excluir o negócio será deletado e não poderá ser reaberto.") }}</span>
    </div>
  </section>
  <div class="btn-group">
    <button @click="handleConfirm">
      {{ __('Excluir') }}
    </button>
    <span @click="handleClose">
      {{ __('Cancelar') }}
    </span>
  </div>
</BModal>
</template>

<style lang="scss" scoped>
section{
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
}

h1 {
  color: #242424;
  text-align: center;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 126%;
  margin-bottom: 4px;
  max-width: 272px;
  margin: auto;
}

h2 {
  color: #242424;
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  margin: 0;
}

form {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 16px;

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;

    img {
      position: absolute;
      right: 10px;
      top: 30px;
    }
  }
}

label {
  color: #242424;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0;
}

textarea {
  height: 66px;
  border-radius: 5px;
  border: 1px solid #D1D1D1;
  resize: none;
  padding: 8px 16px 0;
}

textarea::placeholder {
  color: rgba(128, 128, 128, 0.55);
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
}

.error-text {
  color: #DC3545;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
}

.warning-container {
  display: flex;
  height: 53px;
  width: 264px;
  justify-content: center;
  align-items: center;
  margin: auto;
  gap: 4px;
  border-radius: 14px;
  border: 1px solid #FF6854;
  background: #FFDDC6;

  span {
    color: #242424;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
  }
}

.btn-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    width: 140px;
    border-radius: 14px;
    border: 1px solid #2CEBA9;
    background: #2CEBA9;
    font-size: 16px;
    font-weight: 600;
  }

  button:hover {
    background: #1DC38A;
    border: 1px solid #1DC38A;
    color: #FFF;
  }
  
  span {
    width: 72px;
    height: 18px;
    padding: 0px 8px 0px 9px;
    color: #71767D;
    font-size: 12px;
    font-weight: 600;
    text-decoration-line: underline;
    text-align: center;
    line-height: 150%;
    cursor: pointer;
  }
}
</style>